import { zodResolver } from '@hookform/resolvers/zod';
import type { Resolver } from 'react-hook-form';
import type { z } from 'zod';

export const transformingZodResolver = <TSchema extends z.ZodTypeAny>(schema: TSchema) =>
  zodResolver(schema) as unknown as Resolver<z.input<TSchema>, unknown, z.output<TSchema>>;
